export default function scrollToHash(to = 0, duration = 1000) {
  const getElementOffset = el => {
    const rect = el.getBoundingClientRect();

    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset,
    };
  };

  if (typeof to !== 'number') {
    to = getElementOffset(document.querySelector(to)).top - 20
  }

  const start = document.documentElement.scrollTop || document.body.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = () => {
    currentTime += increment;

    const val = Math.easeInOutQuad(currentTime, start, change, duration);

    document.documentElement.scrollTop = val;
    document.body.scrollTop = val;

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
}

Math.easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};


// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/scroll-to-hash.js